<template>
    <div class="modal fade" tabindex="-1" :id="'kt_modal_' + id">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">{{ $t('department.create_department') }}</h5>
                    <div @click="closeModal" class="btn btn-icon btn-sm btn-active-light-primary ms-2" data-bs-dismiss="modal" aria-label="Close">
                        <span class="svg-icon svg-icon-1">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)"
                                    fill="currentColor"/>
                            <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)"
                                    fill="currentColor"/>
                            </svg>
                      </span>
                    </div>
                </div>
                <div class="modal-body">
                    <DepartmentForm
                        :isLoading="isLoading"
                        :submitMethod="submitCreateMethod"
                        :resetForm="resetForm"
                    />
                </div>
            </div>
        </div>
    </div>
</template>


<script setup>

import DepartmentForm from "./DepartmentForm.vue";
import { useStore } from "vuex";
import {useI18n} from "vue-i18n";
import { ref} from "vue"

const props = defineProps({
    id: {
        type: String,
        default: 'kt_modal_'
    },
    editForm : {
        type: Object,
        required: false
    },
    parent: { type: String, required: false},
    hasParent: { type: Boolean, required: false},
})

const store = useStore()

const resetForm=ref(false)

const emit = defineEmits(['reloadDatatable', 'reloadDepartments'])

const isLoading = ref(false)

const { t } = useI18n({ useScope: 'global' })

function submitCreateMethod(value) {
  storeDepartment(value)
}

function closeModal(){
    resetForm.value=true
    if(props.hasParent){
        $("#"+props.parent).modal('toggle')
    }
    $("#kt_modal_" + props.id).modal('hide')
}

async function storeDepartment(value){
    const newDepartment={name:value}
    isLoading.value = true
    try 
    {
      await store.dispatch('department/createDepartment', newDepartment).then((res) => {
          emit('reloadDepartments', res.data?.data?.id)
          emit('reloadDatatable')
          resetForm.value=false
      })
      isLoading.value = false
      closeModal()
      window.toastr.success(t('notification.department_created'))
    }catch (e) {
        isLoading.value = false 
    }    

}

</script>